//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Images
import Logo from "../../images/Logo.png"
import main_header from "../../images/main_header.png"

const Header = () => {
  return (
    <header className={style.header}>
      <div className={style.header_text_wrapper}>
        <a
          href="https://tascombank.ua/"
          className={style.logo}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={Logo}
            className={style.logo}
            alt="Логотип TАСКОМБАНК і Apple Pay"
          ></img>
        </a>

        <div>
          <h3 className={style.logo_title} alt="TАСКОМБАНК Яблучний ТАС">
            Яблучний ТАС
          </h3>
          <h1 className={style.logo_sub_title}>
            Платіть зручно та безпечно картками Mastercard Таскомбанку в Apple
            Pay
          </h1>
        </div>
        <a
          className={style.gradient_text}
          href="https://tascombank.ua/you/cards"
          id="send_button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Замовити картку
        </a>
      </div>

      <div className={style.wraper_main_images}>
        <img
          src={main_header}
          alt="Таскомбанку в Apple Pay"
          className={style.logo_main_images}
        />
      </div>
      <div className={style.header_border} />
    </header>
  )
}

export default Header
